import React, { useEffect, useState, Fragment, useContext } from "react";
import {
  Row,
  IconWrapper,
  HorizontalSeparator,
  IconBox,
  TextWrapper,
  LogoWrapper,
  BottomLogoWrapper,
} from "../styled/Tooltip.styled";
import { SupplyType, TooltipType, bestSupplyTypeKeyMapper, supplyLvlMapper, formatSupplyLevel } from "../../constants/WebMap";
import TooltipInternal from "./TooltipInternal";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';


export default function OperatorTooltip({
  supplyType,
  geohashStat,
  type = TooltipType.NORMAL,
  anom
}) {
  const { operatorDetails = [], supplyStrengthLevels = {} } = useContext(WebMapContext);

  const [selectedOperator, setSelectedOperator] = useState(null);
  const [bestOperator, setBestOperator] = useState();
  const [otherOperators, setOtherOperators] = useState(null);
  const [customOperator, setCustomOperator] = useState(null);

  useEffect(() => {
    if (geohashStat && supplyType && type) {
      if (type === TooltipType.BEST) {
        let best_operator = geohashStat[bestSupplyTypeKeyMapper[supplyType]];
        let bestOperator = geohashStat.allOperators.filter(
          (item) => item.operator === best_operator
        );
        if (bestOperator.length > 0) {
          let operatorsExceptBestOperator = [];
          geohashStat.allOperators.map((item) => {
            if (item.operator !== bestOperator[0].operator) {
              operatorsExceptBestOperator.push(item);
            }
            return null;
          });
          const oprtData = operatorDetails.find(x => x.operator === best_operator);

          if (!bestOperator[0].isAnonymized) {
            setBestOperator({ ...bestOperator[0], ...oprtData });
          } else { setBestOperator(bestOperator[0]) }

          operatorsExceptBestOperator = [...new Set(operatorsExceptBestOperator.map(s => JSON.stringify(s)))].map(s => JSON.parse(s));
          setOtherOperators(operatorsExceptBestOperator);
          setSelectedOperator(operatorsExceptBestOperator[0]);
        } else {
          setBestOperator(null);
          setOtherOperators(geohashStat.allOperators);
          setSelectedOperator(geohashStat.allOperators[0]);
        }
      } else {
        const { bestOperators } = geohashStat;
        const bestOprtData = bestOperators[supplyType.toLowerCase()];
        if (!bestOprtData?.isAnonymized) {
          const bestOprtDetails = operatorDetails.find(x => x.operator === bestOprtData?.operator);
          setBestOperator({ ...bestOprtData, ...bestOprtDetails });
        } else if (bestOprtData?.isAnonymized) {
          setBestOperator({ ...bestOprtData });
        } else {
          setBestOperator(null);
        }

        const cusOperator = operatorDetails.find(x => x.operator === geohashStat.operator);
        if (anom && anom?.isAnonymized) {
          setCustomOperator({
            ...cusOperator,
            name: anom?.name || "",
            isAnonymized: true
          });
        } else {
          setCustomOperator({
            ...cusOperator,
            isAnonymized: false
          });
        }
      }
    }
  }, [supplyType, geohashStat, type]);

  const onClickOperator = (operator) => {
    setSelectedOperator(operator);
  };

  const CarouselForOtherOps = ({ otherOperators, onClickOperator, operatorDetails, selectedOperator }) => {
    const ITEMS_TO_SHOW = 3;
    const ITEM_WIDTH = 60;
    const TOTAL_ITEMS = otherOperators.length;

    const [currentIndex, setCurrentIndex] = useState(0);
    const scrollRight = () => {
      if (currentIndex + ITEMS_TO_SHOW < TOTAL_ITEMS) {
        setCurrentIndex(prevIndex => prevIndex + 1);
      }
    };

    const scrollLeft = () => {
      if (currentIndex > 0) {
        setCurrentIndex(prevIndex => prevIndex - 1);
      }
    };

    const visibleItems = otherOperators.slice(currentIndex, currentIndex + ITEMS_TO_SHOW);

    return (
      <div style={{ position: 'relative', width: `${ITEM_WIDTH * ITEMS_TO_SHOW + 10}px` }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          {currentIndex + ITEMS_TO_SHOW < TOTAL_ITEMS && (
            <button
              onClick={scrollRight}
              style={{
                position: 'absolute',
                right: '-19px',
                zIndex: 2,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '20px',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
              }}
            >
              <FaChevronRight size={12} color={'#707070'} />
            </button>
          )}
          <div
            style={{
              display: 'flex',
              gap: '0px',
              overflow: 'hidden',
              width: `${ITEM_WIDTH * ITEMS_TO_SHOW}px`,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {visibleItems.map((item, index) => {
              const oprt = operatorDetails.find((x) => x.operator === item.operator);
              return (
                <div
                  key={index}
                  onClick={() => onClickOperator(item)}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: item.isAnonymized ? '52px' : '60px',
                    height: item.isAnonymized ? '30px' : '30px',
                    flex: '0 0 auto',
                    cursor: 'pointer',
                    borderBottom: selectedOperator?.operator === item.operator ? '2px solid rgb(0, 120, 66)' : 'none',
                    opacity: 1,
                    padding: '5px',
                    marginLeft: item.isAnonymized ? '8px' : '0px',
                    background: '#fff',
                    textAlign: 'center',
                  }}
                >
                  {!item.isAnonymized ? (
                    <img
                      src={oprt.icon}
                      alt={oprt.name}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  ) : (
                    <span
                      style={{
                        color: '#707070',
                        font: "normal normal 600 9px/17px Open Sans"
                      }}
                    >
                      {item.name}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
          {currentIndex > 0 && (
            <button
              onClick={scrollLeft}
              style={{
                position: 'absolute',
                left: '-13px',
                zIndex: 2,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '20px',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
              }}
            >
              <FaChevronLeft size={12} color={'#707070'} />
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <div
        style={{
          minWidth: "200px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {type === TooltipType.NORMAL && customOperator && (
          <Fragment>
            <Row style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <LogoWrapper align={"center"} width={"50px"} height={"25px"}>
                {customOperator.icon && !customOperator.isAnonymized
                  ?
                  <img
                    src={customOperator?.icon}
                    alt="logo1"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                    height="auto"
                    vertical-align="middle"
                  />
                  : <h4 style={{
                    color: "#707070",
                    fontSize: "10px",
                    textAlign: "center",
                    lineHeight: "18px",
                    border: "1px solid #016F35",
                    borderRadius: "4px",
                    padding: "3px 5px",
                    display: "inline-block",
                    margin: "20px"
                  }}>{customOperator.name}</h4>}
              </LogoWrapper>
            </Row>
            <HorizontalSeparator />
            <TooltipInternal
              rsrpValue={geohashStat.rsrp ? geohashStat.rsrp : null}
              uploadValue={geohashStat.upload ? geohashStat.upload : null}
              downloadValue={geohashStat.download ? geohashStat.download : null}
              rsrpLevel={geohashStat.rsrp_level ? geohashStat.rsrp_level : null}
              uploadLevel={
                geohashStat.upload_level ? geohashStat.upload_level : null
              }
              downloadLevel={
                geohashStat.download_level ? geohashStat.download_level : null
              }
              supplyType={supplyType}
            />
            <HorizontalSeparator />
          </Fragment>
        )}
        {bestOperator && (
          <Row style={{ height: "30px", marginTop: "18px" }}>
            <IconWrapper>
              <img src={"/assets/bestoperator.png"} alt="logo1" width="13" />
            </IconWrapper>
            <div style={{ width: "100%", fontWeight: "900" }}>
              Best Operator
            </div>
            <LogoWrapper align={"flex-end"} width={"58px"} height={"30px"}>
            {bestOperator?.icon && !bestOperator?.isAnonymized ? (
                <img
                  src={bestOperator?.icon}
                  alt="logo1"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  height="auto"
                  verticalAlign="middle"
                />
              ) : (
                bestOperator?.name && (
                  <h4
                    style={{
                      color: "#707070",
                      fontSize: "10px",
                      textAlign: "center",
                      lineHeight: "18px",
                      border: "1px solid #016F35",
                      borderRadius: "4px",
                      padding: "4px 5px",
                      display: "inline-block",
                      margin: "20px",
                    }}
                  >
                    {bestOperator?.name}
                  </h4>
                )
              )}
            </LogoWrapper>
          </Row>
        )}
        {bestOperator && (
          <Fragment>
            <HorizontalSeparator />
            <TooltipInternal
              rsrpValue={bestOperator.rsrp}
              uploadValue={bestOperator.upload}
              downloadValue={bestOperator.download}
              rsrpLevel={bestOperator.rsrp_level}
              uploadLevel={bestOperator.upload_level}
              downloadLevel={bestOperator.download_level}
              supplyType={supplyType}
            />
            {otherOperators && otherOperators.length > 0 && (
              <Fragment>
                <HorizontalSeparator />
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    height: "30px",
                    alignItems: "center",
                    flexWrap: "wrap"
                  }}
                >
                  <CarouselForOtherOps otherOperators={otherOperators} selectedOperator={selectedOperator} operatorDetails={operatorDetails} onClickOperator={onClickOperator} />
                </Row>
                <HorizontalSeparator />
                <Row>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {supplyType === SupplyType.RSRP && (
                      <IconWrapper>
                        <img
                          src={"/assets/signal.png"}
                          alt="logo1"
                          width="13"
                        />
                      </IconWrapper>
                    )}
                    {supplyType === SupplyType.UPLOAD && (
                      <IconWrapper>
                        <img
                          src={"/assets/upload.png"}
                          alt="logo1"
                          width="13"
                        />
                      </IconWrapper>
                    )}
                    {supplyType === SupplyType.DOWNLOAD && (
                      <IconWrapper>
                        <img
                          src={"/assets/download.png"}
                          alt="logo1"
                          width="13"
                        />
                      </IconWrapper>
                    )}
                    {supplyType === "RSRP" ? "Signal Strength" : supplyType}
                  </div>
                  {selectedOperator && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "80px",
                      }}
                    >
                      {supplyType === SupplyType.RSRP && (
                        <Fragment>
                          {selectedOperator.rsrp
                            ? <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel(selectedOperator[supplyLvlMapper[supplyType]])]} 0% 0% no-repeat padding-box`} />
                            : <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel()]} 0% 0% no-repeat padding-box`} />}
                          <TextWrapper>
                            {selectedOperator.rsrp
                              ? `${selectedOperator.rsrp} dBm`
                              : "No Data"}
                          </TextWrapper>
                        </Fragment>
                      )}
                      {supplyType === SupplyType.UPLOAD && (
                        <Fragment>
                          {selectedOperator.upload
                            ? <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel(selectedOperator[supplyLvlMapper[supplyType]])]} 0% 0% no-repeat padding-box`} />
                            : <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel()]} 0% 0% no-repeat padding-box`} />}
                          <TextWrapper>
                            {selectedOperator.upload
                              ? `${selectedOperator.upload} Mbps`
                              : "No Data"}
                          </TextWrapper>
                        </Fragment>
                      )}
                      {supplyType === SupplyType.DOWNLOAD && (
                        <Fragment>
                          {selectedOperator.download
                            ? <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel(selectedOperator[supplyLvlMapper[supplyType]])]} 0% 0% no-repeat padding-box`} />
                            : <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel()]} 0% 0% no-repeat padding-box`} />}
                          <TextWrapper>
                            {selectedOperator.download
                              ? `${selectedOperator.download} Mbps`
                              : "No Data"}
                          </TextWrapper>
                        </Fragment>
                      )}
                      {supplyType === SupplyType.DATA_RECEIVED && (
                        <Fragment>
                          {selectedOperator.data_received
                            ? <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel(selectedOperator[supplyLvlMapper[supplyType]])]} 0% 0% no-repeat padding-box`} />
                            : <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel()]} 0% 0% no-repeat padding-box`} />}
                          <TextWrapper>
                            {selectedOperator.data_received
                              ? `${selectedOperator.data_received} MB`
                              : "No Data"}
                          </TextWrapper>
                        </Fragment>
                      )}
                      {supplyType === SupplyType.DATA_TRANSMIT && (
                        <Fragment>
                          {selectedOperator.data_transmitted
                            ? <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel(selectedOperator[supplyLvlMapper[supplyType]])]} 0% 0% no-repeat padding-box`} />
                            : <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel()]} 0% 0% no-repeat padding-box`} />}
                          <TextWrapper>
                            {selectedOperator.data_transmitted
                              ? `${selectedOperator.data_transmitted} MB`
                              : "No Data"}
                          </TextWrapper>
                        </Fragment>
                      )}
                      {supplyType === SupplyType.DATA_TRANSCEIVED && (
                        <Fragment>
                          {selectedOperator.data_transceived
                            ? <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel(selectedOperator[supplyLvlMapper[supplyType]])]} 0% 0% no-repeat padding-box`} />
                            : <IconBox backgroundColor={`${supplyStrengthLevels[formatSupplyLevel()]} 0% 0% no-repeat padding-box`} />}
                          <TextWrapper>
                            {selectedOperator.data_transceived
                              ? `${selectedOperator.data_transceived} MB`
                              : "No Data"}
                          </TextWrapper>
                        </Fragment>
                      )}
                    </div>
                  )}
                </Row>
                <HorizontalSeparator />
              </Fragment>
            )}
          </Fragment>
        )}
        {geohashStat.geohash
          ? <p style={{ color: '#707070', font: 'normal normal 600 11px/19px Open Sans', margin: '0px', textAlign: "center" }}>{geohashStat.geohash.toUpperCase()}</p>
          : <></>}
      </div>
    </Fragment>
  );
}
